function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m500.785156 255.996094c0 135.316406-109.695312 245.011718-245.011718 245.011718-135.316407 0-245.011719-109.695312-245.011719-245.011718 0-135.3125 109.695312-245.007813 245.011719-245.007813 135.316406 0 245.011718 109.695313 245.011718 245.007813zm0 0",
  fill: "#fdd33a"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m407.78125 255.996094c0 83.792968-67.925781 151.71875-151.71875 151.71875-83.789062 0-151.714844-67.925782-151.714844-151.71875 0-83.789063 67.925782-151.714844 151.714844-151.714844 83.792969 0 151.71875 67.925781 151.71875 151.714844zm0 0",
  fill: "#fc8e36"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m162.347656 255.996094c0-73.871094 52.800782-135.398438 122.71875-148.933594-9.390625-1.820312-19.082031-2.78125-29.003906-2.78125-83.789062 0-151.714844 67.925781-151.714844 151.714844 0 83.792968 67.925782 151.71875 151.714844 151.71875 9.921875 0 19.613281-.964844 29.003906-2.78125-69.917968-13.535156-122.71875-75.066406-122.71875-148.9375zm0 0",
  fill: "#ed7626"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m393.777344 243.496094c0 18.503906-14.996094 33.503906-33.5 33.503906-18.5 0-33.5-15-33.5-33.503906 0-18.5 15-33.5 33.5-33.5 18.503906 0 33.5 15 33.5 33.5zm0 0",
  fill: "#ffab5f"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m342.777344 185.996094c0 11.597656-9.402344 21-21 21s-21.003906-9.402344-21.003906-21c0-11.601563 9.40625-21.003906 21.003906-21.003906s21 9.402343 21 21.003906zm0 0",
  fill: "#ffab5f"
});

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#fc8e36"
}, React.createElement("path", {
  d: "m256 86.484375c-4.140625 0-7.5-3.359375-7.5-7.503906v-71.480469c0-4.140625 3.359375-7.5 7.5-7.5 4.144531 0 7.5 3.359375 7.5 7.5v71.480469c0 4.144531-3.355469 7.503906-7.5 7.503906zm0 0"
}), React.createElement("path", {
  d: "m256 512c-4.140625 0-7.5-3.359375-7.5-7.5v-71.480469c0-4.144531 3.359375-7.503906 7.5-7.503906 4.144531 0 7.5 3.359375 7.5 7.503906v71.480469c0 4.140625-3.355469 7.5-7.5 7.5zm0 0"
}), React.createElement("path", {
  d: "m433.019531 263.5c-4.144531 0-7.503906-3.355469-7.503906-7.5 0-4.140625 3.359375-7.5 7.503906-7.5h71.480469c4.140625 0 7.5 3.359375 7.5 7.5 0 4.144531-3.359375 7.5-7.5 7.5zm0 0"
}), React.createElement("path", {
  d: "m7.5 263.5c-4.140625 0-7.5-3.355469-7.5-7.5 0-4.140625 3.359375-7.5 7.5-7.5h71.480469c4.144531 0 7.503906 3.359375 7.503906 7.5 0 4.144531-3.359375 7.5-7.503906 7.5zm0 0"
}), React.createElement("path", {
  d: "m381.171875 138.332031c-1.921875 0-3.839844-.734375-5.304687-2.199219-2.929688-2.929687-2.929688-7.675781 0-10.605468l50.546874-50.546875c2.925782-2.929688 7.675782-2.929688 10.605469 0 2.929688 2.929687 2.929688 7.679687 0 10.605469l-50.546875 50.546874c-1.460937 1.464844-3.382812 2.199219-5.300781 2.199219zm0 0"
}), React.createElement("path", {
  d: "m80.285156 439.214844c-1.921875 0-3.839844-.730469-5.304687-2.195313-2.929688-2.929687-2.929688-7.679687 0-10.605469l50.546875-50.546874c2.929687-2.929688 7.675781-2.929688 10.605468 0 2.929688 2.929687 2.929688 7.679687 0 10.605468l-50.546874 50.546875c-1.460938 1.464844-3.382813 2.195313-5.300782 2.195313zm0 0"
}), React.createElement("path", {
  d: "m431.714844 439.214844c-1.917969 0-3.839844-.730469-5.300782-2.195313l-50.546874-50.546875c-2.929688-2.929687-2.929688-7.675781 0-10.605468 2.929687-2.929688 7.675781-2.929688 10.605468 0l50.546875 50.546874c2.929688 2.925782 2.929688 7.675782 0 10.605469-1.464843 1.464844-3.382812 2.195313-5.304687 2.195313zm0 0"
}), React.createElement("path", {
  d: "m130.828125 138.328125c-1.917969 0-3.839844-.730469-5.300781-2.195313l-50.546875-50.546874c-2.929688-2.925782-2.929688-7.675782 0-10.605469 2.929687-2.929688 7.679687-2.929688 10.605469 0l50.546874 50.546875c2.929688 2.929687 2.929688 7.675781 0 10.605468-1.464843 1.464844-3.382812 2.195313-5.304687 2.195313zm0 0"
}));

var SvgSun = function SvgSun(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSun, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sun.004ec82a.svg";
export { ForwardRef as ReactComponent };